import { render } from "./DashboardViewAccess.vue?vue&type=template&id=2cebf863"
import script from "./DashboardViewAccess.vue?vue&type=script&lang=js"
export * from "./DashboardViewAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__